import { render, staticRenderFns } from "./GuidelinesModal.vue?vue&type=template&id=7c2fb116&scoped=true"
import script from "./GuidelinesModal.vue?vue&type=script&lang=js"
export * from "./GuidelinesModal.vue?vue&type=script&lang=js"
import style0 from "./GuidelinesModal.vue?vue&type=style&index=0&id=7c2fb116&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2fb116",
  null
  
)

export default component.exports